import dayjs from 'dayjs'
export const getUnifyTime = function (
  date: string | number | Date,
  format?: string,
): string | number | null {
  if (!date) return date === 0 ? null : date
  if (format === 'date') {
    format = 'YYYY-MM-DD'
  } else if (format === 'time') {
    format = 'YYYY-MM-DD HH:mm:ss'
  }
  if (format === 's') return dayjs(date).startOf('day').valueOf()
  if (format === 'e') return dayjs(date).endOf('day').valueOf()
  return format ? dayjs(date).format(format) : dayjs(date).valueOf()
}
export { dayjs }
